import React, { ReactNode } from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

export default function({ children }: { children: ReactNode }) {
  return <div data-test-id={"Table-Wrap"} className={clsx(styles.tableWrap, 'Table')}>{children}</div>
}
